import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer>
      <p>© 2025 RogiArm. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
